import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
  HttpResponse,
  HttpContextToken
} from '@angular/common/http';

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { MessageService } from '../services/message/message.service';
import { iif, of, throwError } from 'rxjs';
import { LoginService } from '../services/login/login.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BasicDialogComponent, DialogData } from '../shared/componentes/basic-dialog/basic-dialog.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isAlertShown: boolean = false;
  private mensagemTokenInvalido: string = 'invalid_token';
  private mensagemTokenInvalido2: string = 'Erro ao consultar usuário por token.';
  private mensagemTokenInvalido3: string = 'Sessão de usuário expirada. Por favor, refaça o login para acessar o site.';
  public sigla = localStorage.getItem('sigla');
  private dialogReference?: MatDialogRef<BasicDialogComponent, any>;
  constructor(
    private messageService: MessageService,
    private loginService: LoginService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  arrayMensagens: string[] = [
    'Cliente encontrado com sucesso.',
    'Departamentos encontrados com sucesso.',
    'Regiões encontradas com sucesso.',
    'Consulta de usuários realizada com sucesso.',
    'Emails de faturamento ativos encontrados com sucesso.',
    'Ramos(s) de Atividade(s) encontrado(s) com sucesso.',
    'Consulta de usuário realizada com sucesso.',
    'Empresas do usuário localizadas com sucesso.',
    'Consulta de menus realizada com sucesso.',
    'Publicação encontrada com sucesso.',
    'Operação realizada com sucesso',
    'Grupos de Benefício encontrados com sucesso.',
    'Pedido encontrado com sucesso.',
    'Motivos de cancelamento de pedido encontrados com sucesso.',
    'Nota Fiscal encontrado com sucesso.',
    'Cartões encontrados com sucesso.',
    'Lista de repasses do pedido encontrada com sucesso.',
    'Rastreamento do pedido encontrado com sucesso.',
    'Lista de encomendas do pedido encontrada com sucesso.',
    'Lista de itens do pedido encontrada com sucesso.',
    'Guia da encomenda encontrada com sucesso.',
    'Detalhes do Poupador do pedido encontrados com sucesso.',
    'Itens específicos encontrados com sucesso.',
    'Contratos do cliente encontrados com sucesso.',
    'Contrato encontrado com sucesso.',
    'Encomenda do pedido encontrada com sucesso.',
    'Funcionários do detalhe do emissor do pedido encontrados com sucesso.',
    'Cartão encontrado com sucesso.',
    'Períodos encontrados com sucesso.',
    'Funcionário encontrado com sucesso.',
    'Cargos encontrados com sucesso.',
    'Filtro de funcionário encontrado com sucesso.',
    'Benefícios encontrados com sucesso.',
    'Resumo da importação encontrado com sucesso.',
    'Redes de Recarga encontrados com sucesso.',
    'Pedidos Economias encontrados com sucesso.',
    'Motivos de retenção encontrados com sucesso.',
    'Redes de Recarga encontrados com sucesso.',
    'Insumos disponíveis para o funcionário encontrados com sucesso.',
    'Relatório de Notas fiscais gerado com sucesso.',
    'Dados da API de Boletos encontrados com sucesso.',
    'Parâmetros de Sistema encontrados com sucesso.',
    'Consultar de pedidos na listagem de funcionários gerado com sucesso.',
    'Troca de empresa realizada com sucesso.',
    'O arquivo está sendo processado.',
    'Dados encontrados com sucesso.',
    'Processamento finalizado e erros do arquivo importado encontrados com sucesso.',
    'Endereços para tratamento de erros do arquivo importado encontrados com sucesso.',
    'Erros do arquivo importado encontrados com sucesso.',
    'Pedidos avulsos encontrados com sucesso.',
    'Endereços de entrega encontrados com sucesso.',
    'Responsáveis encontrados com sucesso.',
    'Insumos encontrados com sucesso.',
    'O endereço foi associado à importação com sucesso.',
    'Importação concluída com sucesso.',
    'Gera pedidos validações Não Cancelados encontrados com sucesso.',
    'Gera Pedido não cancelado encontrado com sucesso.',
    'Pedidos da solicitação encontrados com sucesso.',
    'Pedidos avulsos encontrados com sucesso.',
    'Endereços de entrega encontrados com sucesso.',
    'Notas fiscais encontradas com sucesso.',
    'Cadastros que precisam ser atualizados encontrados com sucesso.',
    'Não foi possível localizar menus cadastrados para o usuário informado.',
    'Termos de fidelidade encontrado com sucesso.',
    'Dados do funcionário para Gera Pedido validados com sucesso.',
    'Volumes dos contratos encontrados com sucesso.',
    'Configurações de ofertas encontrados com sucesso.',
    'Usuário WEB incluído com sucesso.',
    'Consulta menu para permissões realizada com sucesso.',
    'Pedidos encontrados com sucesso.',
    'Distribuidores para Quadros de Aviso encontrados com sucesso.',
    'Recusado com sucesso.',
    'Próxima data util gerada com sucesso.',
    'Dados para Pedido Personalizado encontrados com sucesso.',
    'Endereços encontrados com sucesso.',
    'Histórico de Pedidos e de Solicitações de pedido encontrados com sucesso.',
    'Dados Pós-pago do cliente encontrados com sucesso.',
    'Consultado se existe algum cliente do grupo vinculado ao pedido com sucesso.',
    'Bundles encontrados com sucesso.',
    'Aceite da(s) oferta(s) incluído(s) com sucesso.',
    'Oferta(s) recusada(s) com sucesso.',
    'Token inativado com sucesso.',
    'Conflitos de pedidos avulsos encontrados com sucesso.',
    'Produtos para boletos encontrados com sucesso.',
    'SVAs ofertados encontrados com sucesso.',
    'Não há SVA aceitável para o canal informado.',
    'Consulta de informações da seção realizada com sucesso.',
    'URL de roteirização CAPTA gerada com sucesso.',
    'Arquivo de retorno consultado com sucesso.'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          (error.error?.error === this.mensagemTokenInvalido && !this.isAlertShown) ||
          (error.error?.mensagem === this.mensagemTokenInvalido2 && !this.isAlertShown) ||
          (error.error?.mensagem === this.mensagemTokenInvalido3 && !this.isAlertShown)
        ) {
          this.isAlertShown = true;
          const dialogData: DialogData = {
            title: 'Sessão expirada',
            message: 'Vamos redirecionar você para a página inicial onde poderá fazer login novamente.',
            action1: 'OK',
            icon: 'error'
          };

          this.dialogReference = this.dialog.open(BasicDialogComponent, {
            width: '300px',
            data: dialogData
          });

          this.dialogReference.afterClosed().subscribe(() => {
            this.loginService.logoutAndRedirect();
            this.isAlertShown = false;
          });
        } else {
          const errorMessage = this.getErrorMessage(error.error?.erros);
          if (!this.arrayMensagens.includes(errorMessage) && !req.context.get(SKIP_ERROR_INTERCEPTOR)) {
            this.messageService.showError(errorMessage, true);
          }

          const UNAUTHORIZED_STATUS = [401, 403];

          if (UNAUTHORIZED_STATUS.includes(error.status)) {
            if (!req.url.includes('demonstrativos')) {
              this.loginService.logoutAndRedirect();
            }
          }
        }

        throw error;
      }),
      switchMap((response: any) =>
        iif(() => response instanceof HttpErrorResponse, throwError(response), of(response))
      ),
      filter((response: any) => response instanceof HttpResponse),
      tap((response: HttpResponse<any>) => {
        if (
          response &&
          response.body &&
          response.body.mensagem &&
          !this.arrayMensagens.includes(response.body.mensagem) &&
          !req.context.get(SKIP_ERROR_INTERCEPTOR)
        ) {
          this.messageService.showError(response.body.mensagem, false);
        }
      })
    );
  }

  private getErrorMessage(erros: Array<{ mensagem: string }>): string {
    if (erros && erros.length > 0) {
      const mensagens = erros.map((erro) => erro.mensagem);
      return mensagens.join(' ');
    } else {
      return 'Ocorreu um erro interno.';
    }
  }
}
